const API_STATES = {
    LOADING: "loading",
    LOADED: "loaded",
    ERROR: "error",
    IDLE: "idle",
};

export default API_STATES;